"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _finance = require("@/api/finance");
var _permission = require("@/utils/permission");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'transferAccount',
  data: function data() {
    return {
      tableData: {
        data: [],
        total: 0
      },
      arrivalStatusList: [{
        label: '已到账',
        value: 1
      }, {
        label: '未到账',
        value: 0
      }],
      closingTypeList: [{
        label: '银行卡',
        value: 'bank'
      }, {
        label: '微信',
        value: 'wechat'
      }, {
        label: '支付宝',
        value: 'alipay'
      }],
      listLoading: false,
      tableFrom: {
        dateLimit: '',
        page: 1,
        limit: this.$constants.page.limit[0],
        closingNo: '',
        auditStatus: '',
        accountStatus: '',
        closingType: ''
      },
      timeVal: [],
      fromList: this.$constants.fromList,
      loading: false,
      dialogVisible: false,
      pictureVisible: false,
      closingData: {},
      transferDialogVisible: false,
      loadingBaseInfo: false,
      transferBaseInfo: {},
      baseInfoform: {
        amount: 1,
        mark: '',
        closingType: ''
      },
      btnLoading: false
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['merchant:finance:closing:page:list'])) this.getList(1);
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 转账信息
    transferDetail: function transferDetail(id) {
      var _this = this;
      this.dialogVisible = true;
      this.loading = true;
      (0, _finance.closingDetailApi)(id).then(function (res) {
        _this.closingData = res;
        _this.closingData.closingProof = JSON.parse(res.closingProof);
        _this.loading = false;
      }).catch(function (res) {
        _this.loading = false;
      });
    },
    // 查看图片
    getPicture: function getPicture(url) {
      this.pictureVisible = true;
      this.pictureUrl = url;
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.baseInfoform.closingType = this.transferBaseInfo.settlementType;
      if (parseFloat(this.baseInfoform.amount) > parseFloat(this.transferBaseInfo.transferMaxAmount)) return this.$message.warning("\u6700\u9AD8\u63D0\u73B0\u989D\u5EA6\u4E3A".concat(this.transferBaseInfo.transferMaxAmount, ",\u8BF7\u4FEE\u6539\u63D0\u73B0\u91D1\u989D"));
      if (parseFloat(this.baseInfoform.amount) > parseFloat(this.transferBaseInfo.transferBalance)) {
        return this.$message.warning('提现金额不能超过可提现金额');
      }
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.btnLoading = true;
          (0, _finance.closingApplyApi)(_this2.baseInfoform).then(function (res) {
            _this2.$message.success('申请成功');
            _this2.btnLoading = false;
            _this2.transferDialogVisible = false;
            _this2.closeFrom();
            _this2.getList(1);
          }).catch(function () {
            _this2.btnLoading = false;
          });
        } else {
          return false;
        }
      });
    },
    closeFrom: function closeFrom() {
      this.baseInfoform = {
        amount: 1,
        mark: '',
        closingType: ''
      };
    },
    // 申请转账
    applyTransfer: function applyTransfer() {
      var _this3 = this;
      this.closeFrom();
      this.transferDialogVisible = true;
      this.loadingBaseInfo = true;
      (0, _finance.closingBaseInfoApi)().then(function (res) {
        _this3.transferBaseInfo = res;
        _this3.loadingBaseInfo = false;
      }).catch(function () {
        _this3.loadingBaseInfo = false;
      });
    },
    // 选择时间
    selectChange: function selectChange(tab) {
      this.tableFrom.dateLimit = tab;
      this.timeVal = [];
      this.getList(1);
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.getList(1);
    },
    // 导出
    exportRecord: function exportRecord() {
      var _this4 = this;
      (0, _finance.transferRecordsExportApi)(this.tableFrom).then(function (res) {
        var h = _this4.$createElement;
        _this4.$msgbox({
          title: '提示',
          message: h('p', null, [h('span', null, '文件正在生成中，请稍后点击"'), h('span', {
            style: 'color: teal'
          }, '导出记录'), h('span', null, '"查看~ ')]),
          confirmButtonText: '我知道了'
        }).then(function (action) {});
      }).catch(function (res) {
        _this4.$message.error(res.message);
      });
    },
    // 导出列表
    getExportFileList: function getExportFileList() {
      this.$refs.exportList.exportFileList();
    },
    handleReset: function handleReset() {
      this.timeVal = [];
      this.tableFrom.closingNo = '';
      this.tableFrom.auditStatus = '';
      this.tableFrom.accountStatus = '';
      this.tableFrom.closingType = '';
      this.getList(1);
    },
    // 列表
    getList: function getList(num) {
      var _this5 = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      (0, _finance.closingRecordListApi)(this.tableFrom).then(function (res) {
        _this5.tableData.data = res.list;
        _this5.tableData.total = res.total;
        _this5.listLoading = false;
      }).catch(function (res) {
        _this5.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList('');
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList('');
    },
    handleClose: function handleClose() {
      this.dialogLogistics = false;
    }
  }
};